import { Expose, Type } from "class-transformer";
import { Model } from "./model";
import { AdminQuery } from "./admin-query-model";
import { ApplicationType } from "../../common";

export class AccountDataModel extends Model {
    @Expose() 
    @Type(() => AdminQuery)
    account: AdminQuery;

    @Expose()
    appsType: ApplicationType[];
}